import KeenSlider from 'keen-slider'
import 'keen-slider/keen-slider.min.css'

export class IntroSlider {
  constructor() {
    const elm = document.getElementById('js-index-intro-slider')
    const animation = { duration: 15000, easing: (t) => t }
    const slider = new KeenSlider(elm, {
      loop: true,
      renderMode: 'performance',
      drag: false,
      slides: {
        perView: 'auto',
      },
      created(s) {
        s.moveToIdx(5, true, animation)
      },
      updated(s) {
        s.moveToIdx(s.track.details.abs + 5, true, animation)
      },
      animationEnded(s) {
        s.moveToIdx(s.track.details.abs + 5, true, animation)
      },
    })
  }
}
